import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const goc = document.getElementById('goc');
if (!goc) throw new Error('Không tìm thấy phần tử gốc #goc');

createRoot(goc).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
